const input = {
    defaultProps: {
        focusBorderColor: 'orange.500',
    },
};

export default input;
